export default "__VITE_ASSET__Dy0ZgAXa__"